import showdown from 'showdown';

export function setQuillContent(quillRef, markdown) {
	const html = new showdown.Converter().makeHtml(markdown);
	const delta = quillRef.current.clipboard.convertHTML(html);
	quillRef.current.setContents(delta);
}
